import * as process from 'process'

const e = window.onerror
window.onerror = function (err) {
  if (err === 'ResizeObserver loop limit exceeded') {
    console.log('Ignored: ResizeObserver loop limit exceeded')
    return true
  }
}

window.Reflect = {
  // @ts-ignore
  decorate: function () {},
  // @ts-ignore
  metadata: function () {},
}

window.global = window
window.process = process
window.Buffer = [] as any

import('./bootstrap')
